import cartType from "./cartType";
  
export const successFetchedCartDetail=(data)=>({
   type: cartType.SET_CART_DETAILS,
   payload: data
})

export const failedFetchedCarttDetail=(data)=>({
   type: cartType.FAILED_FETCHIED_CART_DETAILS,
   errorMessage: data
})


// export const successGetCompanyDetail=(data)=>({
//    type: cartType.SET_COMPANY_DETAILS,
//    payload: data
// })
export const failedFetchedCompanytDetail=(data)=>({
   type: cartType.FAILED_FETCHIED_COMPANY_DETAILS,
   errorMessage: data
})

export const handleSetIsCompany=({
   type: cartType.SET_IS_COMPANY
})

export const handleSetIsPersonal=({
   type: cartType.SET_IS_PERSONAL
})


    
